import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";
import "./CustomTooltip.css";

const CustomTooltip = ({
  children,
  content,
  headerColor = "#EDF8FF",
  interactive = false,
  bodyClassName = "",
}) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const [popupSize, setPopupSize] = useState({ width: 0, height: 0 });
  const wrapperRef = useRef(null);
  const popupRef = useRef(null);
  const hideTimeoutRef = useRef(null);

  const updateCoords = () => {
    const rect = wrapperRef.current.getBoundingClientRect();
    setCoords({
      x: rect.left + window.scrollX,
      y: rect.bottom + window.scrollY,
    });
  };

  const clearHideTimeout = () => {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }
  };

  const showTooltip = () => {
    clearHideTimeout();
    updateCoords();
    setVisible(true);
  };

  const hideTooltip = () => {
    clearHideTimeout();
    setVisible(false);
  };

  const scheduleHide = () => {
    if (!interactive) {
      hideTooltip();
      return;
    }
    clearHideTimeout();
    hideTimeoutRef.current = setTimeout(hideTooltip, 120);
  };

  React.useEffect(() => () => clearHideTimeout(), []);

  // После появления тултипа узнаём его размеры
  React.useEffect(() => {
    if (visible && popupRef.current) {
      setPopupSize({
        width: popupRef.current.offsetWidth,
        height: popupRef.current.offsetHeight,
      });
    }
  }, [visible]);

  // Корректируем позицию, если тултип выходит за границы окна
  let left = coords.x;
  let top = coords.y + 6;
  if (popupSize.width && left + popupSize.width > window.innerWidth - 8) {
    left = window.innerWidth - popupSize.width - 8;
  }
  if (popupSize.height && top + popupSize.height > window.innerHeight - 8) {
    top = coords.y - popupSize.height - 6;
    if (top < 0) top = 8;
  }

  return (
    <span
      className="custom-tooltip__wrapper"
      ref={wrapperRef}
      onMouseEnter={showTooltip}
      onMouseLeave={scheduleHide}
      style={{ position: "relative", display: "inline-block" }}
    >
      {children}
      {visible &&
        ReactDOM.createPortal(
          <div
            className={`custom-tooltip__popup${
              interactive ? " custom-tooltip__popup--interactive" : ""
            }`}
            ref={popupRef}
            style={{
              position: "absolute",
              top,
              left,
              minWidth: 260,
              zIndex: 9999,
            }}
            onMouseEnter={interactive ? showTooltip : undefined}
            onMouseLeave={interactive ? scheduleHide : undefined}
          >
            <div
              className="custom-tooltip__header"
              style={{ background: headerColor }}
            >
              {content.header}
            </div>
            <div className={`custom-tooltip__body ${bodyClassName}`.trim()}>
              {content.body}
            </div>
          </div>,
          document.body
        )}
    </span>
  );
};

export default CustomTooltip;
